import { apiClient } from "@/services/api"
import { defineStore } from "pinia"

export const useFileTagStore = defineStore("fileTag", {
  state: () => ({
    fileTags: [],
  }),
  getters: {
    getFileTags: state => state.fileTags,
  },
  actions: {
    setFileTags(fileTags) {
      this.fileTags = fileTags
    },
    addFileTag(fileTag) {
      this.fileTags.push(fileTag)
    },
    loadAllFileTags() {
      return apiClient.get("/meta/file/tags").then(res => {
        this.setFileTags(res.data)
        return res
      })
    },
    createFileTag(tag) {
      return apiClient.post("/meta/file/tags", { value: tag }).then(res => {
        this.addFileTag(res.data)
        return res
      })
    },
  },
})
